export default __webpack_public_path__ + "static/media/helpful-tip-fall-back-image.2c8ad6b3.jpg";